module.exports = __webpack_public_path__ + "static/media/plus-hexagon.4c2399d2.svg";